import React, { Component } from "react";
import { Dialog, FlatButton, AutoComplete } from "material-ui";

const dataSourceConfig = {
  text: "name",
  value: "id",
};

export default class ClientSearch extends Component {
  state = {
    dataSource: [],
    client: {},
  };

  render() {
    let { dataSource } = this.state;
    let { open, close, onSelect } = this.props;

    const actions = [
      <FlatButton label="Cancel" primary={true} onTouchTap={close} />,
    ];

    return (
      <Dialog title="Client Search" actions={actions} open={open}>
        <AutoComplete
          onUpdateInput={this.handleSearch}
          floatingLabelText="Client"
          fullWidth={true}
          dataSource={dataSource}
          dataSourceConfig={dataSourceConfig}
          onNewRequest={onSelect}
        />
      </Dialog>
    );
  }

  handleSearch = (searchTerm) => {
    let url = "/api/clients/search";
    let options = {
      method: "POST",
      headers: {
        token: this.props.token.jwt,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ searchTerm, jwt: this.props.token.jwt }),
    };
    fetch(url, options)
      .then((res) => {
        if (res.status >= 200 && res.status < 300) return res.json();
      })
      .then((json) => {
        if (json.length > 0) {
          let clients = json.map((client) => {
            let name = `${client.name} | (${client.uid__c})`;
            return { id: client.id, name: name };
          });

          this.setState({ dataSource: clients });
        }
      });
  };
}



// WEBPACK FOOTER //
// ./app/components/clients/ClientSearch.js